import React from 'react';
import Login from './../auth/Login';
import { useNavigate } from 'react-router-dom';
import { ADMIN_EMAILS } from './AdminCommon';

function AdminLogin() {
    let navigate = useNavigate();

    function onLoggedIn(error) {
        if (error) {
            return;
        }

        navigate("/admin");
    }

    return (
        <div>
            <Login 
                specificEmails={ADMIN_EMAILS.join(',')}
                hideSignUpLink 
                hideForgotPasswordLink 
                onLoggedIn={onLoggedIn} 
            />
        </div>
    );
}

export default AdminLogin;
